(function () {
  /* Same-day dispatch message for Townsville (AEST, UTC+10, no daylight saving). */
  var CUTOFF_HOUR = 15; // 3pm AEST
  /* QLD public holidays (YYYY-MM-DD): no same-day dispatch on these days. Add next year's dates each December. */
  var HOLIDAYS = ['2026-10-05', '2026-12-25', '2026-12-28', '2027-01-01', '2027-01-26', '2027-03-26', '2027-03-29', '2027-05-03'];
  var DAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  var boxes = document.querySelectorAll('.timer_2');
  if (!boxes.length) return;

  function aestNow() { return new Date(Date.now() + 10 * 3600000); }
  function dateKey(d) { return d.toISOString().slice(0, 10); }
  function isBusinessDay(d) {
    var day = d.getUTCDay();
    return day !== 0 && day !== 6 && HOLIDAYS.indexOf(dateKey(d)) === -1;
  }
  function nextBusinessDay(d) {
    var n = new Date(d.getTime());
    do { n.setUTCDate(n.getUTCDate() + 1); } while (!isBusinessDay(n));
    return n;
  }
  function render() {
    var now = aestNow();
    var cutoff = new Date(now.getTime());
    cutoff.setUTCHours(CUTOFF_HOUR, 0, 0, 0);
    var html;
    if (isBusinessDay(now) && now < cutoff) {
      var diff = cutoff - now;
      var h = Math.floor(diff / 3600000);
      var m = Math.floor((diff % 3600000) / 60000);
      var s = Math.floor((diff % 60000) / 1000);
      html = 'Order in <span class="timer_shipping">' + h + 'h ' + m + 'm ' + s + 's</span> for <strong>same-day dispatch</strong> from our Townsville store.';
    } else {
      var next = nextBusinessDay(now);
      var tomorrow = new Date(now.getTime());
      tomorrow.setUTCDate(tomorrow.getUTCDate() + 1);
      var when = dateKey(next) === dateKey(tomorrow) ? 'tomorrow' : 'on ' + DAYS[next.getUTCDay()];
      html = 'Order now and it ships <strong>' + when + '</strong> from our Townsville store. Same-day dispatch on weekday orders before 3pm AEST.';
    }
    for (var i = 0; i < boxes.length; i++) boxes[i].innerHTML = html;
  }
  render();
  setInterval(render, 1000);
})();
